module.exports = "<div class=\"card\">\r\n  <h4 class=\"card-header\">404 Not Found</h4>\r\n  <div class=\"card-block\">\r\n    <p>The page you requested was not found.</p>\r\n   <!--  <p>Go to <a routerLink=\"/\">Homepage</a>.</p> -->\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/not-found/not-found.component.html
// module id = ./client/app/not-found/not-found.component.html
// module chunks = main